/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForElastic extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForElastic");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForElastic.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForElastic>): ServiceAccountNativeDetailsForElastic {
        let obj = Object.assign(new ServiceAccountNativeDetailsForElastic(), model);
        ServiceAccountNativeDetailsForElastic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForElastic>): ServiceAccountNativeDetailsForElastic {
        if (!model) return null;
        return ServiceAccountNativeDetailsForElastic.newInstance(<ServiceAccountNativeDetailsForElastic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForElastic) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForElastic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForElastic): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForElastic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
